import request from '@/util/request';
import qs from 'qs';

export const getList = (params, options) =>
  request.get('/api/v4ward/car/stored/page/v2', Object.assign({}, options, {
    params
  }));

export const getrRchargeList = (params, options) =>
  request.get('/api/v4ward/car/recharge/page/v2', Object.assign({}, options, {
    params
  }));

export const getDetail = (params, options) =>
  request.get('/api/park/vehicle/detail/v2', Object.assign({}, options, {
    params
  }));

export const remove = (params, options) =>
  request.post('/api/v4ward/car/stored/remove/v2', qs.stringify(params), options);

export const add = (params, options) => request.post('/api/v4ward/car/stored/save/v2', params, options);

export const update = (params, options) =>
  request.post('/api/v4ward/car/stored/update/v2', params, options);

export const saveCarCharge = (params, options) =>
  request.post('/api/v4ward/car/stored/carStoredRecharge/v2', params, options);

export const carNoChange = (params, options) => request.post('/api/v4ward/car/stored/carNoChange/v2', params, options);

export const checkCarIsExist = (params, options) =>
  request.get('/api/v4ward/car/stored/checkCarIsExist/v2', Object.assign({}, options, {
    params
  }));
